export default "__VITE_ASSET__CD2TfjF6__"